module.exports = __webpack_public_path__ + "img/login-analysis.d00df1f6.jpg";